import CustomView from "@/domain/entities/customViews/CustomView";
import useGetCustomViewContent from "@/hooks/customView/useGetCustomViewContent";
import useGetCustomViewTodos from "@/hooks/customView/useGetCustomViewTodos";
import DocumentsLinksAndSimilar, {
    DocumentsAndLinksVariant,
} from "./attachements/DocumentsLinksAndSimilar";
import Meetings from "./meetings/Meetings";
import Notes from "./notes/Notes";
import SmartTodos from "./todo/SmartTodos";
import { TodoListVariant } from "./todo/TodoList";

type CustomViewWidgetsProps = {
    customView: CustomView;
};

const CustomViewWidgets = ({ customView }: CustomViewWidgetsProps) => {
    const {
        showNotes,
        showTodo,
        showDocuments,
        showLinks,
        showUpcomingMeetings,
    } = customView.widgets;

    const { data: todos, isLoading: isTodosLoading } = useGetCustomViewTodos(
        customView.id,
        showTodo,
    );

    const { documents, links, events } = useGetCustomViewContent(
        customView.id,
        {
            documents: showDocuments,
            links: showLinks,
            events: showUpcomingMeetings,
        },
    );

    return (
        <div className="flex h-full min-h-0 flex-col gap-4 overflow-y-auto">
            {showNotes && (
                <div className="shrink-0">
                    <Notes view={customView} />
                </div>
            )}
            {showUpcomingMeetings && (
                <div className="shrink-0">
                    <Meetings events={events} compact />
                </div>
            )}
            {showTodo && (
                <SmartTodos
                    isLoading={isTodosLoading}
                    todos={todos ?? []}
                    variant={TodoListVariant.CUSTOM_VIEW}
                />
            )}
            {(showDocuments || showLinks) && (
                <div className="shrink-0">
                    <DocumentsLinksAndSimilar
                        documents={showDocuments ? documents : undefined}
                        links={showLinks ? links : undefined}
                        variant={DocumentsAndLinksVariant.CUSTOM_VIEW}
                    />
                </div>
            )}
        </div>
    );
};

export default CustomViewWidgets;
